import axios from '@/plugins/axios'

export default {
  fetchCheckout({commit}) {
    return axios.get('plan/checkout/')
      .then(response => {
        commit('setCheckout', response.data)
      })
      .catch((error) => {
        console.error('Failed to fetch checkout', error)
      })
  },
}
